<template>
  <div class="content">
    <NuevoAvisoModal ref="NuevoAvisoModal" @update="update" />
    <EditarIteracionModal @update="update" />
    <IngresarPagoVirtualModal @update="update" />

    <div class="container-fluid h-100">
      <card-item>
        <div class="d-flex justify-content-end">
          <a :href="link" class="btn btn-danger btn-sm"> Volver</a>
        </div>
      </card-item>

      <div class="row h-100">
        <div class="col h-100">
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <div class="container-fluid h-100">
              <div v-if="ticket" class="row">
                <div class="col-12 col-md-6 form-group form-group-md">
                  <div class="form-group">
                    <label for="NombreCliente" class="label">Cliente</label>
                    <input
                      type="text"
                      class="form-control text-center bg-white"
                      disabled
                      name="NombreCliente"
                      id="NombreCliente"
                      style="cursor: text"
                      :value="nombreCompleto"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6 form-group form-group-md">
                  <div class="form-group">
                    <label for="celular" class="label">Contacto</label>
                    <input
                      type="text"
                      class="form-control text-center bg-white"
                      disabled
                      name="celular"
                      id="celular"
                      style="cursor: text"
                      v-model="ticket.cel_personal"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6 form-group form-group-md">
                  <div class="form-group">
                    <label for="ultimaFactura" class="label"
                      >Última Factura</label
                    >
                    <input
                      type="text"
                      class="form-control text-center bg-white"
                      disabled
                      name="ultimaFactura"
                      id="ultimaFactura"
                      style="cursor: text"
                      v-model="ultimaFactura"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6 form-group form-group-md">
                  <div class="form-group">
                    <label for="deudaActual" class="label">Deuda Actual</label>
                    <input
                      type="text"
                      class="form-control text-center bg-white"
                      disabled
                      name="deudaActual"
                      id="deudaActual"
                      style="cursor: text"
                      v-model="deudaActual"
                    />
                  </div>
                </div>
                <div class="col-12 form-group form-group-md">
                  <div class="form-group">
                    <label for="saldoALaFecha" class="label"
                      >Saldo a la fecha</label
                    >
                    <input
                      type="text"
                      class="form-control text-center bg-white"
                      disabled
                      name="saldoALaFecha"
                      id="saldoALaFecha"
                      style="cursor: text"
                      v-model="saldoALaFecha"
                    />
                  </div>
                </div>
              </div>
              <div
                v-else
                class="d-flex justify-content-center align-items-center"
              >
                <div style="margin: 10px">Cargando...</div>
              </div>
            </div>

            <div class="container-fluid h-100">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="quickFilter" class="label">Filtro rapido</label>
                    <input
                      type="text"
                      class="form-control"
                      id="quickFilter"
                      v-model="quickFilter"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="height: 100%">
                <div class="col" style="position: relative; height: 100%">
                  <ag-grid-vue
                    style="width: 100%; height: 40vh"
                    class="ag-theme-alpine"
                    @grid-ready="onGridReady"
                    :gridOptions="gridOptions"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="iteraciones"
                    :getContextMenuItems="getContextMenuItems"
                  >
                  </ag-grid-vue>
                </div>
              </div>
              <div v-if="ticket" class="row mt-2" style="height: 100%">
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <button
                      @click="ingresarPagoVirtual"
                      type="button"
                      class="btn btn-success"
                    >
                      Ingresar pago virtual
                    </button>
                    <button
                      @click="nuevoAviso"
                      type="button"
                      class="btn btn-primary"
                    >
                      Nuevo aviso
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="d-flex justify-content-center align-items-center"
              >
                <div style="margin: 10px">Cargando...</div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditarIteracionModal from "../../GestionarDeuda/EditarIteracionModal.vue";
import { get } from "lodash-es";
import { AgGridVue } from "ag-grid-vue";
import fechaYHoraComponent from "./Editar/fechaYHoraComponent.vue";
import fechaComponent from "./Editar/fechaComponent.vue";
import { formatM } from "../../../../../lib/utils/accountingJsFns";
import NuevoAvisoModal from "../../GestionarDeuda/NuevoAvisoModal.vue";
import IngresarPagoVirtualModal from "../../GestionarDeuda/IngresarPagoVirtualModal.vue";
import EditarTicketTableActions from "./Editar/EditarTicketTableActions.vue";
import axios from "axios";
import GetFechaCompromiso from "../Historial/Editar/GetFechaCompromiso";

export default {
  name: "EditarTicket",
  data: () => ({
    idCliente: null,
    quickFilter: "",
    ticket: null,
    iteraciones: [],
    pagoVirtual: 0,
    defaultColDef: null,
    gridApi: null,
    gridColumnApi: null,
    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
    columnDefs: [
      {
        headerName: "Fecha y hora",
        cellRendererFramework: fechaYHoraComponent,
        flex: 1,
        sort: "desc",
        comparator: (nodeA, nodeB) => {
          const valA = get(nodeA, "data.creacion", null);
          const valB = get(nodeB, "data.creacion", null);
          return new Date(valA) - new Date(valB);
        },
      },
      {
        headerName: "Motivo",
        flex: 2,
        field: "descripcion",
      },
      {
        headerName: "Fecha de compromiso",
        flex: 1,
        cellRendererFramework: fechaComponent,
        getQuickFilterText: (params) => {
          if (params.data.fecha_compromiso) return params.data.fecha_compromiso;
          return "";
        },
      },
      {
        headerName: "Comentarios",
        flex: 3,
        field: "comentarios",
      },
      {
        headerName: "Acciones",
        cellRendererFramework: EditarTicketTableActions,
      },
    ],
  }),
  beforeMount() {
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  },
  mixins: [GetFechaCompromiso],
  components: {
    AgGridVue,
    NuevoAvisoModal,
    EditarIteracionModal,
    IngresarPagoVirtualModal,
  },
  methods: {
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    update() {
      this.getData();
    },
    nuevoAviso() {
      if (this.ticketResuelto) {
        this.$msgBoxOk(
          "El ticket ya está resuelto. No se puede ingresar aviso.",
          {
            centered: true,
          },
        );
        return;
      } else {
        this.$refs.NuevoAvisoModal.$refs.modal.show();
      }
    },
    ingresarPagoVirtual() {
      if (this.ticketResuelto) {
        this.$msgBoxOk(
          "El ticket ya está resuelto. No se puede ingresar pago. ",
          {
            centered: true,
          },
        );
        return;
      }
      if (this.pagoVirtual && this.pagoVirtual.tiene_pago_virtual != 0) {
        this.$msgBoxOk("Éste ticket ya tiene pago ingresado");
        return;
      } else {
        this.$bvModal.show("ingresarPagoVirtual");
      }
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      await this.getData();
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    async getData() {
      this.gridApi.showLoadingOverlay();

      const resp = await axios.post("/execute", {
        method: "CLI.GetTicketConIteracionesFrontend",
        parameters: [
          {
            name: "id_ticket",
            value: this.$route.params.id_ticket,
          },
        ],
      });
      if (get(resp.data, "ok", false)) {
        this.ticket = get(resp.data, "result[0][0]", null);
        this.iteraciones = get(resp.data, "result[1]", []);
        this.pagoVirtual = get(resp, "data.result[2][0]", 0);
        this.getFechaCompromiso(
          this.iteraciones,
          "creacion",
          "fecha_compromiso",
        );
        this.$store.commit(
          "Suspensiones/EvitarSuspensiones/setIteracionAEditar",
          get(resp.data, "result[1]", []),
        );
        this.$store.commit(
          "Suspensiones/EvitarSuspensiones/setTicket",
          this.ticket,
        );
      }
      this.gridApi.hideOverlay();
      return resp.data;
    },
  },
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    link() {
      return `/#/admin/suspensiones/${this.modo}/${this.$route.params.id_cliente}/historial`;
    },
    nombreCompleto() {
      if (this.ticket) {
        return `${this.ticket.nombre} ${this.ticket.apellido}`;
      }
      return "Cargando...";
    },
    ultimaFactura() {
      const ultFactura = this.ticket.ultima_factura;
      return formatM(ultFactura);
    },
    deudaActual() {
      const DeudaActual = this.ticket.deuda_actual;
      return formatM(Number(DeudaActual));
    },
    saldoALaFecha() {
      const saldoALaFecha = this.ticket.SaldoALaFecha;
      return formatM(Number(saldoALaFecha));
    },
    ticketResuelto() {
      if (this.ticket) {
        const ticketResult = this.ticket.resuelto_fecha;
        return ticketResult;
      }
      return null;
    },
  },
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
